import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "default-table-area style-three employee-leave-request" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle border-0" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex-grow-1 ms-2" }
const _hoisted_10 = { class: "fs-14 fw-medium mb-0" }
const _hoisted_11 = { class: "fs-12 text-body" }
const _hoisted_12 = { class: "fs-14 fw-medium" }
const _hoisted_13 = { class: "fs-14 fw-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 custom-padding-30 border-bottom pb-4" }, [
        _createElementVNode("h3", { class: "mb-0 fw-semibold" }, "Employee Leave Request"),
        _createElementVNode("div", { class: "dropdown select-dropdown" }, [
          _createElementVNode("button", {
            class: "dropdown-toggle bg-transparent border text-body rounded-2",
            style: {"padding-right":"35px"},
            role: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, " This Month "),
          _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }, [
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " This Day ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " This Week ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " This Month ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " This Year ")
            ])
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("thead", { class: "border-bottom" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent fw-normal"
                }, "Employee"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent fw-normal"
                }, "Leave Type"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent fw-normal"
                }, "Days"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent fw-normal"
                }, "Status"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent fw-normal"
                }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leaveRequests, (leave, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          src: leave.image,
                          class: "rounded-circle",
                          alt: "user"
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("h4", _hoisted_10, _toDisplayString(leave.name), 1),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(leave.department), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(leave.leaveType), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(leave.days), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(['badge p-2 fs-12 fw-normal', leave.statusClass])
                    }, _toDisplayString(leave.status), 3)
                  ]),
                  _cache[0] || (_cache[0] = _createElementVNode("td", null, [
                    _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
                      _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-18 text-primary" }, " visibility ")
                      ]),
                      _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-18 text-primary-div-50" }, " border_color ")
                      ]),
                      _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-18 text-danger" }, " delete ")
                      ])
                    ])
                  ], -1))
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode(_component_Pagination, { class: "custom-padding-30 border-0" })
      ])
    ])
  ]))
}